<template>
  <header class="header-expanded py-6 px-5 relative box-border w-full"
    :class="[$dm('bg-white', 'dark:bg-slate-900'), { 'header-in-app': !this.isFullPageView }]">
    <div :class="{ 'full-page-header-container': isFullPageView }">
      <div class=" flex items-start" :class="[avatarUrl ? 'justify-between' : 'justify-end']">
        <img v-if="avatarUrl" class="h-12 rounded-full" :src="avatarUrl" alt="Avatar" />
        <header-actions :show-popout-button="showPopoutButton" />
      </div>
      <h2 v-if="introHeading" v-dompurify-html="introHeading" class="text-lg mb-2 font-weight-heavy"
        :class="[$dm('text-slate-900', 'dark:text-slate-50'), { 'mt-2': !this.isFullPageView }]" />
      <p v-if="introBody" v-dompurify-html="introBody" class="text-sm leading-normal"
        :class="$dm('text-slate-700', 'dark:text-slate-200')" />
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderActions from './HeaderActions.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';
import getConfig from 'widget/helpers/config';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [darkModeMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    isFullPageView() {
      return getConfig().webChannel.isFullPageView;
    },
  },
};
</script>

<style scoped lang="scss">
.header-in-app {
  background: transparent;
}
</style>
